"use client"

import CartTotals from "@modules/common/components/cart-totals"
import DiscountCode from "@modules/checkout/components/discount-code"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { HttpTypes } from "@medusajs/types"

type SummaryProps = {
  cart: HttpTypes.StoreCart
}

function getCheckoutStep(cart: HttpTypes.StoreCart) {
  if (!cart?.shipping_address?.address_1 || !cart.email) {
    return "address"
  } else if (cart?.shipping_methods?.length === 0) {
    return "delivery"
  } else {
    return "payment"
  }
}

const Summary = ({ cart }: SummaryProps) => {
  const step = getCheckoutStep(cart)

  return (
    <div className="flex flex-col gap-4 rounded-rounded border border-jacz-line bg-jacz-white p-6">
      <h2 className="jacz-h3">Twoje zamówienie</h2>
      <DiscountCode cart={cart} />
      <CartTotals totals={cart} />
      <LocalizedClientLink
        href={"/checkout?step=" + step}
        data-testid="checkout-button"
        className="jacz-btn-primary w-full text-center !bg-jacz-green !text-jacz-white hover:!brightness-110"
      >
        Przejdź do zakupu
      </LocalizedClientLink>
      <LocalizedClientLink
        href="/store"
        className="jacz-btn-secondary w-full text-center"
      >
        Kontynuuj zakupy
      </LocalizedClientLink>
      <p className="jacz-body text-sm">
        Zakup bez konta. Konto możesz założyć później.
      </p>
    </div>
  )
}

export default Summary
